import { render, staticRenderFns } from "./BudGet.vue?vue&type=template&id=5308df0d&scoped=true"
import script from "./BudGet.vue?vue&type=script&lang=js"
export * from "./BudGet.vue?vue&type=script&lang=js"
import style0 from "./BudGet.vue?vue&type=style&index=0&id=5308df0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5308df0d",
  null
  
)

export default component.exports